import script from "./EnergyDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./EnergyDashboard.vue?vue&type=script&setup=true&lang=js"

import "./EnergyDashboard.vue?vue&type=style&index=0&id=437afa1a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-437afa1a"]])

export default __exports__